export default "__VITE_ASSET__c4b32934__"